import './Pagination.scss';

export { default } from './Pagination';
